module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/video-poster-1-6fb404ae2e2b7c427858f2b1afe132a3.jpg";